<template>
  <div>
    <el-row>
        <el-col :sm="6" :md="6" :lg="6">
            <Title title="Planificar"
                   subtitle="Crea tu ruta en 3 pasos">
            </Title>
        </el-col>
        <el-col :sm="24" :md="12" :lg="12">
            <div>
              <el-steps :active="active"
                        align-center
                        finish-status="success"
                        class="stepsMaxWidth">
                <el-step  v-for="(step, index) in steps"
                          :title="step"
                          :key="index">
                </el-step>
              </el-steps>
            </div>
        </el-col>
      </el-row>
    <div class="content">
      <el-row>
        <el-col :sm="24" :md="12" :lg="12">
          <div class="stepContainerStyle">
            <PlanningFormStepOne  v-if="active === 0"
                                  ref="formStepOne"
                                  :stepData="form"
                                  :stepFullData="fullDataStep"
                                  @step="setStep"
                                  @handleDataListToCheck="handleDataToCheck"/>
            <PlanningFormStepTwo  v-if="active === 1"
                                  :stepData="form"
                                  :stepFullData="fullDataStep"
                                  @submitFilter="submitFilter"
                                  @step="setStep"
                                  @handleDataListToCheck="handleDataToCheck"/>
            <PlanningFormStepThreeV2  v-if="active === 2"
                                      v-loading = loadingSocs
                                    :stepData="dataChecker"
                                    :stepFullData="fullDataStep"
                                      :datos="socs"
                                      :notFound="notFound"
                                    @step="setStep"
                                    @plan="selectingSocs"
                                    @selectedVehicles="selectVehicle"/>
            <PlanningFormStepFour v-if="active === 3"
                                  :stepData="form"
                                  :planningTracker="planningTracker"
                                  @returnPlan="returnStep1"
                                  @step="setStepStart" />
          </div>
          <el-dialog :visible.sync="dialogVisible" center>
            <h3 class="dialogTitle">
              <i class="fa fa-exclamation-circle" aria-hidden="true"></i>VALIDA TU PLANIFICACIÓN
            </h3>
            <p class="dialogText"><span class="focus">¿Quieres planificar?</span></p>
            <span slot="footer" class="dialog-footer">
              <el-button class="btn small grey"
                         @click="dialogVisible = false">CANCELAR</el-button>
              <el-button size="mini" class="btn small primary" type="primary"
                         @click="submit">ACEPTAR</el-button>
            </span>
          </el-dialog>
        </el-col>
        <el-col :sm="24" :md="12" :lg="12">
          <planning-info-planning style="padding-top: 5px" @useConfig="useConfig" />
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import Title from '../components/base/Title.vue';
import PlanningFormStepOne from '../components/PlanningFormStepOne.vue';
import PlanningFormStepTwo from '../components/PlanningFormStepTwo.vue';
import PlanningFormStepThreeV2 from '../components/PlanningFormStepThreeV2.vue';
import PlanningFormStepFour from '../components/PlanningFormStepFour.vue';
import { apiRequest } from '../../backend/vue-axios/axios';
import {
  getRumDuration,
  startRumTiming,
  trackBusinessFlow,
} from '../../observability/datadogRum';
import PlanningInfoPlanning from '../components/PlanningInfoPlanning.vue';

export default {
  name: 'PlanningIndex',
  components: {
    Title,
    PlanningFormStepOne,
    PlanningFormStepTwo,
    PlanningFormStepThreeV2,
    PlanningFormStepFour,
    PlanningInfoPlanning,

  },
  data() {
    return {
      finish: false,
      planningTracker: { number: null },
      steps: ['ct', 'Ordenes', 'Planifica'],
      active: 0,
      dialogVisible: false,
      fullDataStep: {},
      loadingSocs: false,
      socs: [],
      socsToPlanning: [],
      notFound: true,
      form: {
        enterprises_id: [],
        distribution_centers_id: [],
        time_init: '',
        time_finish: '',
        communes_id: [],
        document_types_id: [],
        package_types_id: [],
        delivery_methods_id: [],
        time_windows_tags_id: [],
        travel_types_id: '',
        transfer_centers_id: 0,
      },
      dataChecker: {
        enterprises_id: [],
        distribution_centers_id: [],
        time_init: '',
        time_finish: '',
        communes_id: [],
        document_types_id: [],
        time_windows_tags_id: [],
        package_types_id: [],
        travel_types_id: '',
        transfer_centers_id: 0,
      },
    };
  },
  computed: {
  },
  methods: {
    useConfig(item) {
      this.form = {
        enterprises_id: item.enterprises_id,
        distribution_centers_id: item.distribution_centers_id,
        time_init: item.time_init,
        time_finish: item.time_finish,
        region: item.region,
        communes_id: item.communes_id,
        document_types_id: item.document_types_id,
        package_types_id: item.package_types_id,
        travel_types_id: item.travel_types_id,
        time_windows_tags_id: item.time_windows_tags_id,
        transfer_centers_id: item.transfer_centers_id,
        // vehicle_list: [],
      };
      this.dataChecker = {
        enterprises_id: item.enterprises_id_g,
        distribution_centers_id: item.distribution_centers_id_g,
        time_init: item.time_init_g,
        time_finish: item.time_finish_g,
        region: item.region_g,
        communes_id: item.communes_id_g,
        document_types_id: item.document_types_id_g,
        package_types_id: item.package_types_id_g,
        travel_types_id: item.travel_types_id_g,
        time_windows_tags_id: item.time_windows_tags_id_q,
        transfer_centers_id: item.transfer_centers_id_g,
        delivery_methods_id: item.delivery_methods_id_g,
      };
      this.active = 0;
      this.$refs.formStepOne.dateFocus();
    },
    selectingSocs(socs) {
      if (this.form.vehicle_list) {
        this.dialogVisible = true;
        const aux = socs.filter(soc => soc.dp_id !== 0 && soc.verified && soc.last_state !== 6);
        this.socsToPlanning = aux.map(val => val.suborder);
        trackBusinessFlow({
          module: 'planning',
          flow: 'planning_v2',
          action: 'selection_ready',
          status: 'success',
          context: {
            selected_suborders: this.socsToPlanning.length,
            selected_vehicles: this.form.vehicle_list.length,
          },
        });
      } else {
        trackBusinessFlow({
          module: 'planning',
          flow: 'planning_v2',
          action: 'selection_ready',
          status: 'blocked',
        });
        this.$message({
          type: 'warning',
          title: 'Advertencia',
          message: 'Necesitas seleccionar correctamente los vehiculos a planificar',
          duration: 5000,
          showClose: true,
        });
      }
    },
    selectVehicle(vehicles) {
      if (vehicles.length > 0) {
        // eslint-disable-next-line
        this.form["vehicle_list"] = vehicles;
      } else {
        delete this.form.vehicle_list;
      }
    },
    handleDataToCheck(data, fullData) {
      Object.keys(data).forEach((elementType) => {
        this.dataChecker[elementType] = data[elementType];
      });
      this.fullDataStep = fullData;
    },
    setStepStart(el) {
      this.clearData();
      this.active = el;
    },
    returnStep1(el) {
      this.active = el;
      this.clearData();
    },
    setStep(el) {
      this.active = el;
    },
    submitFilter() {
      this.loadingSocs = true;
      this.socs = [];
      const startedAt = startRumTiming();
      let exists = null;
      let aux = [];
      aux = JSON.parse(JSON.stringify(this.form.distribution_centers_id));
      exists = this.form.document_types_id.find(element => element === 6 || element === 7);
      if ((exists === 6 || exists === 7) && this.form.region !== 13) {
        aux.push(8000);
      }
      trackBusinessFlow({
        module: 'planning',
        flow: 'planning_v2',
        action: 'suborders_filter_requested',
        status: 'attempt',
        context: {
          selected_distribution_centers: aux.length,
          distribution_center_count: aux.length,
          distribution_center_scope: aux.length === 0 ? 'none' : aux.length === 1 ? 'single' : 'multiple',
          selected_communes: this.form.communes_id.length,
          region_id: this.form.region,
        },
      });
      apiRequest({
        module: 'planning',
        service: 'filter_soc_to_planning',
        params: {
          requested_at: this.form.time_init, // '2019-09-17T10:00:00Z',
          communes_id: this.form.communes_id, // [135, 154, 402],
          document_types_id: this.form.document_types_id, // [8],
          package_types_id: this.form.package_types_id, // [1, 2, 3, 4, 5, 6, 7, 8],
          travel_types_id: this.form.travel_types_id, // 9,
          // excluded_delivery_methods: this.form.delivery_methods_id, // [1],
          time_windows_tags_id: this.form.time_windows_tags_id,
          region: this.form.region,
          distribution_centers_id: aux, // [9918],
        },
      }).then((res) => {
        // eslint-disable-next-line func-names
        res.data.forEach((value) => {
          // eslint-disable-next-line no-param-reassign
          value.verified = true;
          this.socs.push(value);
        });
        this.loadingSocs = false;
        trackBusinessFlow({
          module: 'planning',
          flow: 'planning_v2',
          action: 'suborders_filter_completed',
          status: 'success',
          durationMs: getRumDuration(startedAt),
          context: {
            matched_suborders: this.socs.length,
            distribution_center_count: aux.length,
            distribution_center_scope: aux.length === 0 ? 'none' : aux.length === 1 ? 'single' : 'multiple',
            region_id: this.form.region,
          },
        });
      }).catch(() => {
        trackBusinessFlow({
          module: 'planning',
          flow: 'planning_v2',
          action: 'suborders_filter_completed',
          status: 'empty',
          durationMs: getRumDuration(startedAt),
        });
        this.$message({
          type: 'warning',
          title: 'Advertencia',
          message: 'No se encontraron folios para los filtros ingresados, puedes agregarlos de forma manual en la planificación.',
          duration: 5000,
          showClose: true,
        });
        this.loadingSocs = false;
      });
    },
    submit() {
      this.dialogVisible = false;
      this.active = 3;
      const startedAt = startRumTiming();
      if (this.form.transfer_centers_id === '') {
        delete this.form.transfer_centers_id;
      }
      const newForm = this.form;
      newForm.suborder_list = this.socsToPlanning;
      trackBusinessFlow({
        module: 'planning',
        flow: 'planning_v2',
        action: 'planning_requested',
        status: 'attempt',
        context: {
          selected_suborders: this.socsToPlanning.length,
          selected_vehicles: this.form.vehicle_list ? this.form.vehicle_list.length : 0,
          distribution_center_count: this.form.distribution_centers_id.length,
          distribution_center_scope: this.form.distribution_centers_id.length === 0 ? 'none' : this.form.distribution_centers_id.length === 1 ? 'single' : 'multiple',
          region_id: this.form.region,
        },
      });
      apiRequest({
        module: 'planning',
        service: 'planning_with_soc_list',
        params: newForm,
      }).then((data) => {
        this.planningTracker.number = data.data.planning_tracker;
        this.finish = true;
        this.$notify.success({
          title: 'OK',
          message: 'Tu planificación fue realizada',
        });
        trackBusinessFlow({
          module: 'planning',
          flow: 'planning_v2',
          action: 'planning_completed',
          status: 'success',
          durationMs: getRumDuration(startedAt),
          context: {
            planning_tracker: data.data.planning_tracker,
            distribution_center_count: this.form.distribution_centers_id.length,
            distribution_center_scope: this.form.distribution_centers_id.length === 0 ? 'none' : this.form.distribution_centers_id.length === 1 ? 'single' : 'multiple',
            region_id: this.form.region,
          },
        });
      }).catch((error) => {
        trackBusinessFlow({
          module: 'planning',
          flow: 'planning_v2',
          action: 'planning_completed',
          status: 'error',
          durationMs: getRumDuration(startedAt),
          context: {
            http_status: error.response ? error.response.status : 0,
          },
        });
        if (error.response) {
          let respuesta = '';
          if (error.response.status === 404) {
            respuesta = 'No se encontraron subordenes con los parametros dados';
          } else if (error.response.status === 400) {
            respuesta = 'Problemas con los parametros, revisalo e intentalo nuevamente';
          } else if (error.response.status === 500) {
            respuesta = 'Error inesperado, intentelo más tarde';
          }
          this.$notify({
            type: error.response.status !== 404 ? 'error' : 'warning',
            title: error.response.status !== 404 ? 'Error' : 'Problema',
            message: respuesta,
          });
        }
        this.active = 0; // Retorna a paso 1 de planning
      });
    },
    clearData() {
      this.form.enterprises_id = [];
      this.form.distribution_centers_id = [];
      this.form.time_init = '';
      this.form.time_finish = '';
      this.form.communes_id = [];
      this.form.document_types_id = [];
      this.form.package_types_id = [];
      this.form.travel_types_id = '';
      this.delivery_methods_id = [];
      this.form.transfer_centers_id = 0;
      delete this.from.vehicle_list;
    },
  },
};
</script>

<style lang="scss" scoped>
  .steps {
  }
  .content {
  }
  .topTitle {
    text-transform: uppercase;
    font-size: 14px;
    text-align: left;
    margin: 0 0 1.2em;
  }
  .focus {
    text-transform: uppercase;
    font-weight: 900;
    color: #AAD500;
    &.small {
      display: block;
      font-style: italic;
      margin-top: 0.5em;
      font-size: 0.85em;
    }
  }
  .tooltipStyle {
    color: #AAD500;
    font-size: 16px;
  }
  @media only screen and (max-width: 767px) {
    .content {
      margin: 0;
    }
    .summary {
      margin: 0 30px;
    }
  }
.stepsMaxWidth {
  max-width: 90%;
}
.stepContainerStyle {
  //max-height: 500px;
  //overflow: scroll;
  width: 90%;
  border: 1px solid #E0E0E0;
  margin-top: 5px;
  padding: 1em;
  box-sizing: border-box;
}
.dialogText {
  width: 90%;
  margin: auto;
}
.label {
  text-transform: uppercase;
  font-size: 10px;
  color: #606266;
  margin-bottom: 5px;
}

.greenTitle{
  font-size: 15px;
  color: #AAD500;
  margin: 0;
  text-align: left;
  font-weight: 900;
  text-transform: uppercase;
}
.greySubTitle{
  color: #707070;
  font-weight: 300;
  text-align: left;
  font-size: 14px;
  margin: 0 0 1em;
}
.dialogTitle {
  padding: 0 40px;
  font-size: 1.2em;
  text-transform: uppercase;
  font-weight: 600;
  margin-top: 0;
  .fa-exclamation-circle {
    color: #F5A623;
    font-size: 1.4em;
    margin-right: 0.5em;
  }
}
.focus {
  text-transform: uppercase;
  font-weight: 600;
  color: #707070;
  margin-left: 38px;
  display: block;
}
</style>
